export default function calculatePagination(pageNumber: number, limitItems = 15) {
  const initial = (pageNumber - 1) * limitItems;

  return {
    initial,
    final: initial + limitItems,
  };
}
